import { ShipmentStatus } from '#/shared/api/generated/shipment/models'

import { SHIPMENT_STAGES } from '../model/stages'
import type { ShipmentStage } from '../model/stages'

const STAGE_DEFAULT_STATUS: Record<ShipmentStage, ShipmentStatus> = {
  [SHIPMENT_STAGES.LEAD]: ShipmentStatus.lead,
  [SHIPMENT_STAGES.QUOTE]: ShipmentStatus.quote,
  [SHIPMENT_STAGES.ORDER]: ShipmentStatus.order,
}

export function defaultStatusForStage(stage: ShipmentStage): ShipmentStatus {
  return STAGE_DEFAULT_STATUS[stage]
}
